const ADMIN_ROLE = 'admin';

export default function userIsAdmin(user) {
  return Boolean(user?.role?.toLowerCase().includes(ADMIN_ROLE));
}
